import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasSmartResizeGenerated.meta';

export type UseTrackCanvasSmartResizeGeneratedParams = {
  canvas_id: string;
  node_type: 'image' | 'video';
  format_ids: string[];
  platforms: string[];
  format_count: number;
  custom_size_count: number;
  source: 'canvas_toolbar' | 'edit_in_canvas' | 'empty_state';
  auto_run: boolean;
  size_set_id?: string;
};

export const useTrackCanvasSmartResizeGenerated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasSmartResizeGenerated = useCallback(
    (params: UseTrackCanvasSmartResizeGeneratedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasSmartResizeGenerated };
};
